import React from 'react';
import PropTypes from 'prop-types';
import { FormattedDate, injectIntl } from 'react-intl';

function nonUsDateFormat(datestring) {
  if (!datestring) {
    return datestring
  }
  var date = new Date(datestring);
  var month = date.getMonth() + 1;
  var day = date.getDate();

  return [day, month, date.getFullYear()].join('.');
}

// because of the way our locale strings ('en','de'...) are set up, we need to handle 'en' dates separately
// the react-intl FormattedDate expects a locale of 'en-GB' in order to display a DD/MM/YYYY date
// since we're just passing 'en', it thinks it's 'en-US' resulting in MM/DD/YYYY
const CustomDate = (props) => {
  if (props.intl.locale === 'en') {
    return (
      <span>
        {nonUsDateFormat(props.value)}
      </span>
    )
  } else if (props.value) {
    return (
      <FormattedDate value={props.value} />
    )
  } else {
    return null;
  }
}

CustomDate.propTypes = {
  intl: PropTypes.object,
}

export default injectIntl(CustomDate);
